import {translateFunction} from "../../../../localization/TranslationService";
import {pageAuthorizedByGroup} from "../../../fragments/PageAuthorization";
import {Autocomplete, Box, Breadcrumbs, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField} from "@mui/material";
import React, {useState} from "react";
import {useQuery} from "@apollo/client";
import {GET_ALL_CUSTOM_ATTRIBUTES_SETUP, SUPPLIER_INDEX} from "../../Queries";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {productsEditorDefaultTargetStage, productsEditorTargetStage} from "../../ProductModuleOverview";
import {CustomAttributeSetup} from "../../models/CustomAttributeSetup";
import {Link} from "react-router-dom";
import {CustomAttributeBulkEditorProducts} from "./CustomAttributeBulkEditorProducts";
import {HeaderSlot, StageSwitch} from "../../../../components/onsite/Footer";

const translate = translateFunction("SureBasePortalProductsCatalog");
export const CustomAttributeBulkEditorProductsWizard = pageAuthorizedByGroup(function () {
	const [customAttributes, setCustomAttributes] = useState<CustomAttributeSetup[]>();
	const [selectCustomAttributes, setSelectCustomAttributes] = useState<CustomAttributeSetup[]>();
	const [selectedCustomAttributeIds, setSelectedCustomAttributeIds] = useState<string[]>([]);

	const [productSuppliers, setProductSuppliers] = useState();
	const [selectedProductSupplierKrn, setSelectedProductSupplierKrn] = useState("");
	const [proceed, setProceed] = useState(false);
	const supplierIndex = useQuery(SUPPLIER_INDEX, {
		client: graphQLServices.productsClient,
		fetchPolicy: "no-cache",
		variables: {
			stage: productsEditorTargetStage,
		}
	});

	const {loading, data, error} = useQuery(GET_ALL_CUSTOM_ATTRIBUTES_SETUP, {
		client: graphQLServices.productsClient,
		fetchPolicy: "no-cache",
		variables: {
			stage: productsEditorTargetStage,
		}
	});

	if (supplierIndex.loading || loading)
		return <Box sx={{display: "flex", width: "100%", height: "100%"}}>
			<CircularProgress style={{margin: "auto"}}/>
		</Box>;

	const attributeNodes = data.customAttributeSetup.nodes;
	if (attributeNodes === null || attributeNodes?.length === 0)
		throw new Error(translate(`CustomAttributeSetups not found.`));

	if (!customAttributes) {
		setCustomAttributes(attributeNodes);
	}

	if (!productSuppliers) {
		const clone = supplierIndex.data.productSuppliers.nodes
			.map((it: any, index: number) => ({label: it.legalName + "  -   " + it.krn, value: it.krn, id: index}));
		clone.sort((a: any, b: any) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
		setProductSuppliers(clone);

	}

	if (!selectCustomAttributes) {
		setSelectCustomAttributes(attributeNodes);
	}

	function openProductBulkEditor() {
		if (!customAttributes)
			return;
		const attributes = [];
		const lookup = new Set<string>(selectedCustomAttributeIds);
		for (const item of customAttributes) {
			if (lookup.has(item.id))
				attributes.push(item);
		}
		setSelectCustomAttributes(attributes);
		setProceed(true);
	}

	return (
		<>

			<Breadcrumbs style={{margin: "5px"}}>
				<Link style={{color: "inherit", textDecoration: "unset"}} to="/products">{translate("Products")}</Link>
				<Link style={{color: "inherit", textDecoration: "unset"}} to="/products/custom_attribute_bulk">{translate("Custom attribute bulk editor options")}</Link>
			</Breadcrumbs>
			{!proceed &&
				<Stack gap={1} alignContent={"start"} style={{maxWidth: "700px"}}>
					<HeaderSlot><StageSwitch defaultTargetStage={productsEditorDefaultTargetStage}/></HeaderSlot>
					<Stack>
						<InputLabel id={"custom-attributes"}>{translate("Custom attributes")}</InputLabel>
						<Select
							labelId={"custom-attributes"}
							label={translate("Custom attributes")+":"+selectedCustomAttributeIds.length}
							variant={"standard"}
							multiple={true}
							value={selectedCustomAttributeIds}
							onChange={event => setSelectedCustomAttributeIds(event.target.value as string[])}
						>
							<MenuItem key={"null"} value={""} hidden={true} style={{display: "none"}}></MenuItem>
							{selectCustomAttributes?.map(it =>
								<MenuItem key={it.id} value={it.id}>{it.description} - {it.mapping}</MenuItem>)}
						</Select>
					</Stack>
					<Stack>
						<Autocomplete
							disablePortal
							options={productSuppliers ?? []}
							autoSelect
							autoComplete
							renderInput={(params) => <TextField
								{...params}
								label={translate("Product Supplier")}
								variant={"standard"}
							/>}
							getOptionLabel={(it: any) => it.label}
							onChange={(event, item) => {
								setSelectedProductSupplierKrn(item.value);
							}}
						/>
					</Stack>
					<Button disabled={selectedCustomAttributeIds.length === 0 || !selectedProductSupplierKrn || selectedProductSupplierKrn === ""} onClick={openProductBulkEditor} color={"success"}>{translate("Edit products")}</Button>
				</Stack>
			}

			{proceed &&
				<CustomAttributeBulkEditorProducts customAttributes={selectCustomAttributes || []} supplierKrn={selectedProductSupplierKrn}/>
			}
		</>
	);
}, ["Admin", "Product"]);

